import React from "react";

import {
  Container,
  Description,
  HiddenInput,
  LabelContent,
  LabelText,
  RadioButton,
  VisualWrapper,
} from "./styled";
import type { RadioProps } from "./types";

export const Radio: React.FC<RadioProps> = ({
  checked,
  defaultChecked,
  onChange,
  disabled = false,
  size = "medium",
  label,
  description,
  labelPosition = "right",
  styleProps,
  className,
  testId,
  ...props
}) => {
  const [internalChecked, setInternalChecked] = React.useState(
    defaultChecked ?? false,
  );
  const isControlled = checked !== undefined;
  const checkedValue = isControlled ? checked : internalChecked;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newChecked = event.target.checked;
    if (!isControlled) {
      setInternalChecked(newChecked);
    }
    onChange?.(newChecked);
  };

  return (
    <Container
      $disabled={disabled}
      $labelPosition={labelPosition}
      $styleProps={styleProps}
      className={className}
      data-testid={testId}
    >
      <VisualWrapper>
        <RadioButton
          $size={size}
          $checked={checkedValue}
          $disabled={disabled}
          $styleProps={styleProps}
        />
        <HiddenInput
          type="radio"
          checked={checkedValue}
          onChange={handleChange}
          disabled={disabled}
          {...props}
        />
      </VisualWrapper>
      {(label || description) && (
        <LabelContent>
          {label && (
            <LabelText $disabled={disabled} $styleProps={styleProps}>
              {label}
            </LabelText>
          )}
          {description && (
            <Description $disabled={disabled} $styleProps={styleProps}>
              {description}
            </Description>
          )}
        </LabelContent>
      )}
    </Container>
  );
};
